export const PRISM_BORDER_STEP_1 = '#0065FF';
export const PRISM_BORDER_STEP_2 = '#0469FF';
export const PRISM_BORDER_STEP_3 = '#BF63F3';
export const PRISM_BORDER_STEP_4 = '#FFA900';
